import type React from 'react';
import styles from '../../common/GridTableComponent/gridTableTemplate.module.scss';
import { Typography } from '@mui/material'
import { apiRequest } from '../../../infrastructure/backendService';
import { useEffect, useState } from 'react';
import { ClipLoader } from "react-spinners";
import { formatAmount } from '../../common/StyledComponents/StyledFields';

export interface GridTableProps {
   tableData?: any[];
   columnMapping?: Record<string, string>;
   sendDataToParent?:any;
   getReportData?:any;
   getAmountData?:any;
   getTotalDrillDownData?:any;
   reqBody?:any;
   resData?:any;
   sendDrillDownRequestBody?:any;
}

export default function FrontDeskIncomeReportGridTable(props: GridTableProps): JSX.Element {   
   // console.log('props',props)
const [searchNameText, setSearchNameText] = useState<any>('')
const [dayName, setDayName] = useState<string>('')
const [monthName, setMonthName] = useState<string>('')
const [date, setDate] = useState<number>()
const [year, setYear] = useState<number>()
const [searchStartDate, setSearchStartDate] = useState<any>()
const [loading, setLoading] = useState(false);

const getTableData = (): any => {
   return props.tableData;
};

const handleDrilDownAPI = (item:any)=>{
   apiCall(item);
}

 const apiCall = (item:any):any => { 
   // let reqBody: any = {};
   let reqBody: any = {
      searchStartDate: getDayWeekMonthYear(props.reqBody.searchStartDate),
      searchEndDate: getDayWeekMonthYear(props.reqBody.searchEndDate),
      // "donationTypeId": item.typeId,
      "pagination": true,
      "pageNumber": 1
    };
    props.resData.forEach((subItem:any)=>{
      Object.entries(subItem).forEach(([key, value]: any)=>{
         if(key === 'incomeByDonationType' && Array.isArray(value)){
            value.forEach((obj:any)=>{
               if(obj.typeid === item.typeId){
                reqBody.donationTypeId = item.typeId
               }
            })
         }else if(key === 'incomeByPoojaPurpose' && Array.isArray(value)){
            value.forEach((obj:any)=>{
               if(obj.typeid === item.typeId){
                reqBody.poojaTypeId= item.typeId
               }
            })
         }else if(key === 'incomeByDonationPurpose' && Array.isArray(value)){
            value.forEach((obj:any)=>{
               if(obj.typeid === item.typeId){
                reqBody.donationsPurposeId = item.typeId
               }
            })
         }
      })
    })
    setLoading(true);
   apiRequest({
     method: "POST",
     endpoint: '/report-dashboard/reports/treasury/INCOME_REPORT_DONATION_POOJA_REPORT/browser',
     body: JSON.stringify(reqBody),
     includeToken: true,
   })
     .then((res: any) => {
      setLoading(false);
      props.sendDataToParent(true,{reqBody,reportName:'FrontDeskDrillDownReport'});   
     let counter = 1;
      const response = res.data.data.map((drillItem:any)=>{
            return {
               "Sr No":drillItem.sno || counter++,
               "Receipt Number":drillItem.receiptnumber,
               "Reference Number":drillItem.referencenumber,
               "Name (Sign-in)":drillItem.name,
               "Mode of Payment":drillItem.modeofpayment,
               "Check Number":drillItem.checknumber,
               "Description":drillItem.description,
               "Donation/Puja (ID)":drillItem.donationpoojaid,
               "Date of Payment":drillItem.dateofpayment,
               "Amount":formatAmount(drillItem.amount),
               type:drillItem.type
            }
      })
      // props.getReportData(res.data.data);
      props.getReportData(response);
      // props.getAmountData(res.data.totalDonatedAmount);
      props.sendDrillDownRequestBody(reqBody)
      props.getTotalDrillDownData(res.data);
     })
     .catch((err: any) => {
      console.log('err',err)
      setLoading(false);
      const emptyData = [{
         "receiptnumber": null,
         "referencenumber": null,
         "name": null,
         "modeofpayment": null,
         "checknumber": null,
         "description": null,
         "donationpoojaid": null,
         "dateofpayment": null,
         "amount": null
      }]
      props.sendDataToParent(true,{reqBody,reportName:'DrillDownReport'});
      props.getReportData(emptyData);
      // props.getAmountData(0);
      props.getTotalDrillDownData({totalElements:0,totalDonatedAmount:0});
     });
 };

 useEffect(()=>{
   reportTitle()
   getDayWeekMonthYear(props.reqBody.searchStartDate)
   searchDate()
 },[searchNameText])

const reportTitle = ()=>{
   const keysToCheck = ['yearlySearch', 'weeklySearch', 'monthlySearch', 'dailySearch','customSearch'];
   const existingKey = keysToCheck.find(key => Object.keys(props.reqBody).includes(key));
   const searchBy = existingKey?.split('S')[0]
   const searchName = searchBy?.toUpperCase()
   setSearchNameText(searchName)
}

const getDayWeekMonthYear = (searchDate:any)=>{
   // const dateString = props.reqBody.searchStartDate;
   // const dateParts = dateString.split('/');
   const dateParts = searchDate.split('/');
   const month = parseInt(dateParts[0], 10); // Month (0-11), hence subtracting 1 to make it (1-12)
   const date = parseInt(dateParts[1], 10); // Date (1-31)
   const year = parseInt(dateParts[2], 10); // Year
   // Add leading zero if month or date is single digit
   const formattedMonth = month.toString().padStart(2, '0');
   const formattedDate = date.toString().padStart(2, '0');
   const day = new Date(year, month - 1, date).getDay(); // Day (0-6, 0 = Sunday, 1 = Monday, ..., 6 = Saturday)
   const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
   const dayName = daysOfWeek[day];
   const monthsOfYear = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
   const monthName = monthsOfYear[month - 1];
   setDayName(dayName)
   setMonthName(monthName)
   setDate(date)
   setYear(year)
   return `${year}-${formattedMonth}-${formattedDate}`
}

const searchDate = ()=>{
 switch(searchNameText){
   case "DAILY" :
      setSearchStartDate(`(${dayName}, ${monthName} ${date}, ${year})`)
      break;
    case "WEEKLY" :
      setSearchStartDate(`(${props.reqBody.searchStartDate})`)
      break;
    case "MONTHLY" :
      setSearchStartDate(`(${monthName} ${year})`)
      break;
    case "YEARLY" :
      setSearchStartDate(`(${year})`)
      break;
    case "CUSTOM" :
      setSearchStartDate(`(${props.reqBody.searchStartDate} 00:00:00 AM to ${props.reqBody.searchEndDate} 11:59:59 PM)`)
      break;
    default:
      setSearchStartDate(props.reqBody.searchStartDate)
      break;
 }
}

   const renderTable = (): React.ReactElement => {
      return (
         <>
         <Typography className={styles.typoGraphyHeader} style={{textAlign:'center',margin:'10px 0'}}>
            {`${searchNameText} INCOME REPORT`} {searchStartDate}              
            </Typography>
            {loading && (
                <>
                <div style={{position:'sticky',top:'50%',zIndex:'999', textAlign:'center'}}>
                  <ClipLoader color="#000" loading={loading} size={25} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                  </span>
                  </div>
                </>
              )}
         <div className={`${styles.tableContainer} grid-table`}>
            <table className={styles.tableContainer} style={{borderRadius:"0 !important"}}>
              {props.columnMapping && <thead>
                  <tr className={styles.headerTableRow}>
                     {Object?.keys(getTableData()[0])?.map((key : any, index : number) => (
                        <th className={styles.tableHorizontal} key={index}>
                           {props?.columnMapping?.[key]}
                        </th>
                     ))}
                  </tr>
               </thead>}
               <tbody>
                  {getTableData().map((item : any, index : number) => (
                     <tr key={index} 
                     className={`${item?.Title?.includes('Total Income') || 
                     item?.Title?.includes('Total Puja Income') || 
                     item?.Title?.includes('Total Donations Income') ? 
                     styles.headerTableRow_IncomeReport : 
                     styles.tableRow_IncomeReport}`}>
                         <td className={styles.tableDiagonal}>
                           {item.link ? 
                           (<span onClick={()=>handleDrilDownAPI(item)} style={{textDecoration:'underline',cursor:"pointer"}}>{item.Title}</span>) 
                           : (item.Title)}
                        </td>
                        <td className={styles.tableDiagonal} style={{textAlign:'right'}}>{item.Amount}</td>
                     </tr>
                  ))}
               </tbody>
            </table>
         </div>
         </>
      );
   };
   return <>{renderTable()}</>;
}
